import { ArrowRight, CalendarCheck, MessagesSquare, Workflow, Rocket, ShieldCheck } from "lucide-react";
import { Container, Reveal, SectionHeader } from "./common";
import { useDemoModal } from "./DemoModal";

const highlights = [
    {
        icon: Workflow,
        title: "Tailored to your process",
        desc: "Pipelines, fields, workflows and automation shaped around how your team actually sells.",
    },
    {
        icon: Rocket,
        title: "Onboarding included",
        desc: "Spreadsheet migration, data import and team setup — done with you, not left to you.",
    },
    {
        icon: ShieldCheck,
        title: "Scales when you do",
        desc: "Start with a few users and grow into field sales, engagement and analytics on the same platform.",
    },
];

const Pricing = () => {
    const { openDemo } = useDemoModal();
    return (
        <section id="pricing" data-testid="pricing-section" className="bg-[#F7FEF9]/60 py-20 lg:py-28">
            <Container>
                <SectionHeader
                    eyebrow="Pricing"
                    title="Plans that fit your business"
                    sub="Every business has different requirements. Talk to our team to find the right Kryvo CRM setup for your sales operation."
                />
                <Reveal delay={0.15}>
                    <div className="relative mx-auto mt-14 max-w-4xl overflow-hidden rounded-[28px] border border-[#E5E7EB] bg-white shadow-xl shadow-slate-900/[0.05]">
                        <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#16A34A]/[0.07] blur-3xl" />
                        <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-[#16A34A]/[0.05] blur-3xl" />
                        <div className="relative grid gap-8 p-8 sm:p-10 lg:grid-cols-3">
                            {highlights.map((h) => (
                                <div key={h.title} className="flex flex-col items-start">
                                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#F0FDF4]">
                                        <h.icon className="h-5 w-5 text-[#16A34A]" />
                                    </span>
                                    <h3 className="mt-4 font-display text-base font-bold text-[#111827]">{h.title}</h3>
                                    <p className="mt-1.5 text-sm leading-relaxed text-[#64748B]">{h.desc}</p>
                                </div>
                            ))}
                        </div>
                        <div className="relative flex flex-col items-center gap-4 border-t border-[#F1F5F9] bg-[#FBFDFC] px-8 py-8 sm:flex-row sm:justify-center">
                            <button
                                onClick={openDemo}
                                data-testid="pricing-btn-contact-us"
                                className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#16A34A] px-8 py-3.5 text-[15px] font-semibold text-white shadow-lg shadow-[#16A34A]/25 transition-all hover:-translate-y-0.5 hover:bg-[#15803D] sm:w-auto"
                            >
                                <MessagesSquare className="h-4 w-4" />
                                Contact Us
                                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                            </button>
                            <button
                                onClick={openDemo}
                                data-testid="pricing-btn-book-demo"
                                className="group flex w-full items-center justify-center gap-2 rounded-full border border-[#E5E7EB] bg-white px-8 py-3.5 text-[15px] font-semibold text-[#111827] transition-all hover:-translate-y-0.5 hover:border-[#16A34A]/40 hover:text-[#15803D] sm:w-auto"
                            >
                                <CalendarCheck className="h-4 w-4 text-[#16A34A]" />
                                Book a Demo
                                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                            </button>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-8 text-center text-sm font-medium text-[#64748B]">
                        14-day free trial · Cancel anytime · Secure & reliable
                    </p>
                </Reveal>
            </Container>
        </section>
    );
};

export default Pricing;
